import { indexBy, head, prop } from 'ramda';
import { SaveDashboardApiT } from './api';

export function serverToClientDashboard(serverResponse: IServerDashboard[]): IDashboard {
  const headOfCollection = head(serverResponse);
  if (!headOfCollection) {
    throw new Error('No dashboard with provided ID');
  }
  const { meta, widgets } = headOfCollection;
  return {
    meta,
    widgets: indexBy(prop('widgetId'), widgets)
  };
}

export const clientToServerDashboard = (dashboard: IDashboard): SaveDashboardApiT => ({
  meta: dashboard.meta,
  widgets: Object.values(dashboard.widgets)
});
